const purples = {
    dark: '#534767',
    light: '#988798',
}

const colors = {
    APP_WHITE: '#fefefe',
    APP_BLACK: '#000',
    APP_GRAY: '#ccc',
    APP_GRAY_LIGHT: '#eee',
    APP_GRAY_DARK: '#aaa',

    COLOR_PRIMARY: purples.dark,
    BUTTON_DARK: purples.dark,

    BACK_BUTTON: purples.light,

    APP_TEXT: '#212529',
}

export default colors
